function AIAssitIco() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3762 17.4515C18.4194 17.5388 18.4897 17.6097 18.5765 17.6537L20.2177 18.4837C20.547 18.6502 20.547 19.1203 20.2177 19.2868L18.5765 20.1169C18.4897 20.1609 18.4194 20.2318 18.3762 20.3191L17.5613 21.9679C17.3962 22.3021 16.9196 22.3021 16.7545 21.9679L15.9396 20.3191C15.8965 20.2318 15.8262 20.1609 15.7393 20.1169L14.0981 19.2868C13.7689 19.1203 13.7689 18.6502 14.0981 18.4837L15.7393 17.6537C15.8262 17.6097 15.8965 17.5388 15.9396 17.4515L16.7545 15.8026C16.9196 15.4685 17.3962 15.4685 17.5613 15.8026L18.3762 17.4515Z"
        stroke="#00CEAC"
        stroke-width="2"
      />
      <path
        d="M10.301 9.6453C10.4048 9.85178 10.5727 10.019 10.7797 10.1219L13.7683 11.608C14.5582 12.0008 14.5582 13.1277 13.7683 13.5205L10.7797 15.0066C10.5727 15.1095 10.4048 15.2767 10.301 15.4832L8.79928 18.4705C8.40498 19.2549 7.28524 19.2549 6.89094 18.4705L5.38925 15.4832C5.28546 15.2767 5.11749 15.1095 4.91056 15.0066L1.92192 13.5205C1.13198 13.1277 1.13198 12.0008 1.92192 11.608L4.91056 10.1219C5.11749 10.019 5.28546 9.85178 5.38925 9.6453L6.89094 6.65793C7.28524 5.87353 8.40498 5.87354 8.79928 6.65793L10.301 9.6453Z"
        stroke="#00CEAC"
        stroke-width="2"
      />
      <path
        d="M20.36 4.39446C20.4178 4.51073 20.5117 4.60512 20.6277 4.66347L22.9344 5.8237C23.3749 6.04527 23.3749 6.67414 22.9344 6.89572L20.6277 8.05595C20.5117 8.11429 20.4178 8.20869 20.36 8.32496L19.2105 10.6381C18.9899 11.0821 18.3565 11.0821 18.1359 10.6381L16.9864 8.32496C16.9286 8.20869 16.8347 8.11429 16.7187 8.05595L14.4121 6.89572C13.9716 6.67414 13.9716 6.04527 14.4121 5.8237L16.7187 4.66347C16.8347 4.60512 16.9286 4.51073 16.9864 4.39446L18.1359 2.08127C18.3565 1.63728 18.9899 1.63728 19.2105 2.08127L20.36 4.39446Z"
        stroke="#00CEAC"
        stroke-width="2"
      />
    </svg>
  );
}

export default AIAssitIco;
